import React from 'react'
import Link from 'gatsby-link'

const MissionStatement = () => (
  <section className="py-24 px-6 bg-white">
    <div className="container mx-auto text-center max-w-4xl">
      {/* Decorative element */}
      <div
        className="w-16 h-1 mx-auto mb-8 rounded-full"
        style={{
          background: 'linear-gradient(90deg, #635bff 0%, #11efe3 100%)'
        }}
      />

      <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6 leading-tight">
        We Love To See You Smile!
      </h2>

      <p className="text-xl text-textSecondary leading-relaxed mb-10 max-w-3xl mx-auto">
        We offer cutting-edge technology, comprehensive services, and an
        experienced staff that combine to give you amazingly effective dental
        care.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/appointments"
          className="inline-flex items-center justify-center px-8 py-4 bg-primary text-white font-semibold text-base rounded-lg transition-all duration-150 hover:bg-primaryDark"
          style={{
            boxShadow: '0 4px 14px 0 rgba(99, 91, 255, 0.39)'
          }}
        >
          Book Your Visit
        </Link>
        <Link
          to="/treatments"
          className="inline-flex items-center justify-center px-8 py-4 font-semibold text-base rounded-lg transition-all duration-150 text-textPrimary hover:bg-offWhite"
          style={{
            border: '1px solid #e3e8ee'
          }}
        >
          View Our Services
          <svg
            className="w-4 h-4 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </Link>
      </div>
    </div>
  </section>
)

export default MissionStatement
